export default __webpack_public_path__ + "static/media/ionic-logo-youtube.dbb8dfc6.svg";